import React, { useState, useEffect } from 'react';
import { X, Send, Loader2, Calendar, MessageSquare } from 'lucide-react';
import api from '../../api/axios';
import toast from 'react-hot-toast';
import styles from './IntimateModal.module.css';

const IntimateModal = ({ isOpen, onClose, submission, onSuccess }) => {
  const [formData, setFormData] = useState({
    intimate_date: new Date().toISOString().split('T')[0],
    intimate_remark: ''
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setFormData({
        intimate_date: new Date().toISOString().split('T')[0],
        intimate_remark: ''
      });
    }
  }, [isOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.intimate_date || !formData.intimate_remark) {
      toast.error('Please fill in all fields');
      return;
    }

    setLoading(true);
    try {
      const response = await api.put(`/design-submissions/${submission.id}`, formData);
      if (response.data.success) {
        toast.success('Vendor intimated successfully');
        onSuccess();
        onClose();
      }
    } catch (error) {
      console.error('Error intimating vendor:', error);
      toast.error(error.response?.data?.message || 'Failed to intimate vendor');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className={styles['modal-overlay']} onClick={onClose}>
      <div className={styles['modal-content']} onClick={(e) => e.stopPropagation()}>
        <div className={styles['modal-header']}>
          <div className={styles['header-title']}>
            <div className={styles['icon-box']}>
              <Send size={20} />
            </div>
            <div>
              <h3>Intimate to Vendor</h3>
              <p>LOI: <span className={styles['po-highlight']}>{submission?.purchase_order?.po_number}</span></p>
            </div>
          </div>
          <button className={styles['close-btn']} onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className={styles['modal-body']}>
          <div className={styles['input-group']}>
            <label>
              <Calendar size={16} />
              Intimate to Vendor Date
            </label>
            <input
              type="date"
              value={formData.intimate_date}
              onChange={(e) => setFormData({ ...formData, intimate_date: e.target.value })}
              required
            />
          </div>

          <div className={styles['input-group']}>
            <label>
              <MessageSquare size={16} />
              Remark
            </label>
            <textarea
              placeholder="Enter intimacy remark..."
              value={formData.intimate_remark}
              onChange={(e) => setFormData({ ...formData, intimate_remark: e.target.value })}
              required
              rows={4}
            />
          </div>

          <div className={styles['modal-footer']}>
            <button type="button" className={styles['cancel-btn']} onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className={styles['submit-btn']} disabled={loading}>
              {loading ? (
                <>
                  <Loader2 size={18} className={styles['spinner']} />
                  <span>Processing...</span>
                </>
              ) : (
                <>
                  <Send size={18} />
                  <span>Submit Intimacy</span>
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default IntimateModal;
